import moment from 'moment'

export const isDateBeforeMonths = (value, months) => {
  try {
    return moment(value).isBefore(moment().subtract(months, 'months'))
  } catch (e) {
    return false
  }
}
